import * as React from 'react';
import cn from 'classnames';
import { isString, isUndefined } from 'lodash-es';
import { ColorPreset, getBGColorClass, getBorderColorClass, getBorderWidthClass, BorderRadiusLocation, getBorderRadiusClass, getDisplayClass, useSpacingProps, maxWidthClass } from '../../../library';
import { getFlexAlignClass, getFlexJustifyClass } from '../../../utilities';
export var Pane = function Pane(props) {
  var _useSpacingProps = useSpacingProps(props),
    marginClasses = _useSpacingProps.marginClasses,
    paddingClasses = _useSpacingProps.paddingClasses;
  var classNames = cn(isUndefined(props.display) ? '' : getDisplayClass(props.display), isUndefined(props.flexAlign) ? '' : getFlexAlignClass(props.flexAlign), isUndefined(props.flexJustify) ? '' : getFlexJustifyClass(props.flexJustify), isUndefined(props.bgColor) ? '' : getBGColorClass(props.bgColor), isUndefined(props.borderRadius) ? '' : getBorderRadiusClass(isString(props.borderRadius) ? props.borderRadius : props.borderRadius.size, isString(props.borderRadius) ? BorderRadiusLocation.ALL : props.borderRadius.location), isUndefined(props.border) ? '' : getBorderWidthClass(isString(props.border) ? props.border : props.border.width, isString(props.border) ? BorderRadiusLocation.ALL : props.border.location), isUndefined(props.borderColor) ? isUndefined(props.border) ? '' : getBorderColorClass(ColorPreset.GRAY_400) : getBorderColorClass(props.borderColor), marginClasses, paddingClasses, props.className, maxWidthClass(props.maxWidth));
  var TagName = props.as;
  return React.createElement(TagName, {
    className: classNames,
    style: props.style,
    children: props.children
  });
};
Pane.displayName = 'Pane';
Pane.defaultProps = {
  as: 'div'
};